import { CopyOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { UserInvitationLink } from '@hefe/models';
import { Button, Col, Input, message, Row, Space, Typography } from 'antd';
import QRCode from 'react-qr-code';
import { environment } from '../../../../../environments/environment';

interface InvitationLinkComponentProps {
  link: UserInvitationLink;
}

export default function InvitationLinkComponent(
  props: InvitationLinkComponentProps
) {
  const { link } = props;

  const url = environment.frontendUrl + '/#/register/' + link.token;

  const onClickCopyToClipboard = () => {
    navigator.clipboard.writeText(url);
    message.success(t('user_invitation.copied_to_clipboard'));
  };

  return (
    <Row style={{ width: '100%' }} align="middle">
      <Col xs={24}>
        <Typography.Paragraph>
          {t('user_invitation.warning')}
        </Typography.Paragraph>
        <QRCode value={url} />
        <Space style={{ width: '100%', marginTop: 20 }}>
          <Input value={url} disabled style={{ width: '90%' }} />
          <Button onClick={() => onClickCopyToClipboard()}>
            <CopyOutlined />
          </Button>
        </Space>
      </Col>
    </Row>
  );
}
